import React, { useEffect, useState, forwardRef } from "react";

const AnimatedNumber = forwardRef(({ start, end, duration, children, ...props }, ref) => {
  const [count, setCount] = useState(start);

  useEffect(() => {
    if (start === end) {
      setCount(end);
      return;
    }

    let current = start;
    const range = end - start;
    const increment = end > start ? 1 : -1;

    const step = Math.max(1, Math.floor(duration / Math.abs(range)));

    const timer = setInterval(() => {
      current += increment;
      setCount(current);
      if (current === end) {
        clearInterval(timer);
      }
    }, step);

    return () => clearInterval(timer);
  }, [start, end, duration]);

  return (
    <span ref={ref} {...props} >
      {count}
      {children}
    </span>
  );
});

export default AnimatedNumber;
